
import { Helmet } from "react-helmet";

const KayttoehdotPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Helmet>
        <title>Käyttöehdot | Lainasampo.fi</title>
        <meta name="description" content="Lainasampo.fi:n käyttöehdot määrittelevät lainojen vertailupalvelumme käyttöä koskevat ehdot ja käytännöt." />
      </Helmet>
      
      <h1 className="text-3xl font-bold mb-6 text-blue-700">Käyttöehdot</h1>
      
      <div className="bg-white p-6 rounded-lg shadow-sm border border-blue-100 mb-8">
        <p className="mb-4">Tervetuloa Lainasampo.fi-palveluun! Nämä käyttöehdot määrittelevät sinun ja Lainasampo Oy:n välistä suhdetta. Käyttämällä palveluamme hyväksyt nämä ehdot ja sitoudut noudattamaan niitä.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">1. Palvelun kuvaus</h2>
        <p className="mb-4">Lainasampo.fi on lainojen vertailu- ja kilpailutuspalvelu, joka välittää lainahakemuksia yhteistyökumppaneilleen. Lainasampo.fi ei itse myönnä lainoja, vaan toimii välittäjänä asiakkaiden ja rahoituslaitosten välillä.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">2. Palvelun käyttö</h2>
        <p className="mb-4">Käyttäessäsi palveluamme sinun tulee:</p>
        <ul className="list-disc ml-6 mb-4 space-y-2">
          <li>Antaa oikeat ja ajantasaiset tiedot lainahakemuksessa</li>
          <li>Olla vähintään 18-vuotias ja oikeustoimikelpoinen</li>
          <li>Käyttää palvelua vain laillisiin tarkoituksiin</li>
          <li>Noudattaa Suomen lakia ja näitä käyttöehtoja</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">3. Lainahakemukset</h2>
        <p className="mb-4">Lähettämällä lainahakemuksen Lainasampo.fi:n kautta:</p>
        <ul className="list-disc ml-6 mb-4 space-y-2">
          <li>Valtuutat meidät välittämään hakemuksesi yhteistyökumppaneillemme</li>
          <li>Hyväksyt, että yhteistyökumppanimme voivat tarkistaa luottotietosi</li>
          <li>Ymmärrät, että lopullisen lainapäätöksen tekee rahoituslaitos, ei Lainasampo.fi</li>
          <li>Hyväksyt, että voimme olla sinuun yhteydessä lainahakemukseesi liittyen</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">4. Lainatarjoukset</h2>
        <p className="mb-4">Lainatarjoukset ovat yhteistyökumppaneidemme tekemiä. Emme voi taata, että saat lainatarjouksia tai että tarjoukset vastaavat odotuksiasi. Saamiesi tarjousten ehdot riippuvat useista tekijöistä, kuten luottotiedoistasi, tuloistasi ja rahoituslaitosten luotonantopolitiikasta.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">5. Maksuttomuus</h2>
        <p className="mb-4">Lainasampo.fi:n palvelut ovat maksuttomia asiakkaille. Rahoitamme toimintamme yhteistyökumppaneidemme maksamilla välityspalkkioilla.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">6. Vastuunrajoitukset</h2>
        <p className="mb-4">Lainasampo.fi ei ole vastuussa:</p>
        <ul className="list-disc ml-6 mb-4 space-y-2">
          <li>Yhteistyökumppanien tekemistä lainapäätöksistä tai tarjousten ehdoista</li>
          <li>Lainojen takaisinmaksusta tai lainanottajan ja lainanantajan välisistä suhteista</li>
          <li>Palvelun käytön mahdollisesti aiheuttamista epäsuorista tai välillisistä vahingoista</li>
          <li>Palvelun tilapäisistä käyttökatkoista tai teknisistä ongelmista</li>
        </ul>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">7. Immateriaalioikeudet</h2>
        <p className="mb-4">Kaikki Lainasampo.fi:n sisältö, mukaan lukien tekstit, kuvat, logot, tietokoneohjelmat ja muu materiaali, on suojattu immateriaalioikeuksilla ja kuuluu Lainasampo Oy:lle tai sen lisenssiantajille. Sisällön kopiointi, jakaminen tai muu käyttö ilman lupaa on kielletty.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">8. Viestintä</h2>
        <p className="mb-4">Käyttämällä palveluamme hyväksyt, että voimme lähettää sinulle sähköpostitse tai muuten sähköisesti tietoa palvelustamme, lainahakemuksestasi ja lainatarjouksista. Voit milloin tahansa peruuttaa markkinointiviestinnän suostumuksen ottamalla yhteyttä asiakaspalveluumme.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">9. Ehtojen muutokset</h2>
        <p className="mb-4">Pidätämme oikeuden muuttaa näitä käyttöehtoja. Julkaisemme muutetut ehdot verkkosivustollamme ja ne tulevat voimaan välittömästi. Sivuston käyttö ehtojen muutosten jälkeen katsotaan uusien ehtojen hyväksymiseksi.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">10. Sovellettava laki ja riitojen ratkaisu</h2>
        <p className="mb-4">Näihin käyttöehtoihin sovelletaan Suomen lakia. Mahdolliset riidat pyritään ratkaisemaan ensisijaisesti neuvottelemalla. Jos sopua ei synny, riidat ratkaistaan Helsingin käräjäoikeudessa.</p>
        
        <h2 className="text-xl font-semibold mb-3 text-blue-700 mt-6">11. Yhteystiedot</h2>
        <p className="mb-4">Jos sinulla on kysyttävää käyttöehdoista, ota yhteyttä:</p>
        <p>
          Lainasampo Oy<br />
          Sähköposti: asiakaspalvelu@lainasampo.fi
        </p>
      </div>
      
      <p className="text-sm text-gray-500 text-center mb-8">Nämä käyttöehdot on päivitetty viimeksi: 1.6.2023</p>
    </div>
  );
};

export default KayttoehdotPage;
